import { useEffect, useRef, useState } from 'react';
import PhotoExamples from './PhotoExamples';

export default function EvidenceUpload({ category, label, help, existing, file, onChange, onError, required }: {
  category: string; label: string; help: string; required?: boolean; existing?: { url?: string }; file?: File;
  onChange: (file?: File) => void; onError: (error: string) => void;
}) {
  const input = useRef<HTMLInputElement>(null);
  const [preview, setPreview] = useState('');
  const video = category.startsWith('VIDEO_');
  useEffect(() => {
    if (!file) { setPreview(''); if (input.current) input.current.value = ''; return; }
    const url = URL.createObjectURL(file); setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);
  const url = preview || (existing?.url && /^https?:\/\//i.test(existing.url) ? existing.url : '');
  return <div className="border rounded p-3 mb-2">
    <strong>{label}</strong><small className="d-block mb-2">{help}</small>
    {url && (video
      ? <video className="d-block mb-2" src={url} controls preload="metadata" style={{ maxWidth: '100%', maxHeight: 200 }} aria-label={label} />
      : <a href={url} target="_blank" rel="noopener noreferrer"><img className="d-block mb-2 rounded" src={url} alt={label} style={{ maxWidth: '100%', maxHeight: 180 }} /></a>)}
    {file ? <span className="d-block text-primary mb-2">{file.name} — aguardando salvar</span>
      : existing && <span className="d-block text-success mb-2">Arquivo já enviado.</span>}
    <input ref={input} id={`viability-file-${category}`} type="file" className="visually-hidden" aria-label={label}
      required={required ?? (!existing && !file)} accept={video ? '.mp4,.mov' : '.jpg,.jpeg,.png,.webp'} onChange={e => {
        const selected = e.target.files?.[0];
        if (!selected) return;
        if (selected.size === 0 || selected.size > (video ? 100 : 10) * 1024 * 1024) {
          onError(`Selecione um arquivo de até ${video ? 100 : 10} MB.`); e.target.value = ''; return;
        }
        onError(''); onChange(selected);
      }} />
    <button type="button" className="btn btn-outline-primary me-2" onClick={() => input.current?.click()}>
      {existing || file ? `Substituir ${video ? 'vídeo' : 'imagem'}` : `Selecionar ${video ? 'vídeo' : 'imagem'}`}
    </button>
    {!video && <PhotoExamples category={category} label={label} />}
    {file && <button type="button" className="btn btn-link" onClick={() => {
      if (input.current) input.current.value = ''; onChange();
    }}>{existing ? 'Cancelar substituição' : 'Remover seleção'}</button>}
    <small className="d-block mt-2">{video ? 'MP4 ou MOV, até 100 MB.' : 'JPG, PNG ou WebP, até 10 MB.'}</small>
  </div>;
}
